 <template>
  <div class="right">
    <RightTop @data="getCreditDataFn"></RightTop>

    <div class="rightCenter">
      <div class="centerTit">主要股东</div>
      <div class="centerCon">
        <div class="no">
          <span>截止日期：</span>
          <el-select
            @change="deadlineFun(selectDate.value)"
            v-model="selectDate.value"
            size="small"
            placeholder="请选择"
          >
            <el-option v-for="item in selectDate.deadline" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </div>
        <div class="excel" @click="downloadTable()">
          <img src="@/assets/img/Excel.png" alt />
          下载数据到Excel
        </div>
      </div>
    </div>
    <div class="rightBottom">
      <div class="tabulation">
        <!-- 表格纵列 -->
        <div class="tabulationTop">
          <div class="tabulationTopTitle">
            <table>
              <tr>
                <th>截止日期</th>
              </tr>
              <tr>
                <th>公告日期</th>
              </tr>
              <tr>
                <th class="custom">股东总数</th>
              </tr>
              <tr>
                <th class="custom" border="none">平均持股数(股)</th>
              </tr>
            </table>
          </div>
          <div class="con">
            <table>
              <!-- 截止日期 -->
              <tr>
                <td>{{closingDate.substr(0,10)}}</td>
              </tr>
              <!-- 公告日期 -->
              <tr>
                <td>{{announcementDate.substr(0,10)}}</td>
              </tr>
              <!-- 股东总数 -->
              <tr>
                <td>
                  {{shareholdersNumbers}}
                  <span class="trends" @click="lookTrends()">查看变化趋势</span>
                </td>
              </tr>
              <!-- 平均持股数 -->
              <tr>
                <td>
                  {{averageStockHoldings}}
                  <span class="trends" @click="lookBalance()">查看变化趋势</span>
                </td>
                <!-- <td>{{majorList[0].averageStockHoldings}}</td>   -->
              </tr>
            </table>
          </div>
        </div>
        <!-- 下部横向 -->
        <div class="tabulationBottom">
          <el-table :data="majorList" style="width: 100%" border size="mini">
            <el-table-column label="序号" width="140">
              <template slot-scope="scope">{{scope.$index+1}}</template>
            </el-table-column>
            <af-table-column prop="shareholderName" label="股东名称"></af-table-column>
            <af-table-column prop="capitalStockNature" label="股本性质"></af-table-column>
            <af-table-column prop="shareholdersNumber" label="持股数量(股)"></af-table-column>
            <af-table-column prop="shareholdingRatio" label="持有比例(%)"></af-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- 遮罩层 -->
    <!-- <div class="shade" v-show="shade" @click="closeMark()">
      <div class="shadeBox">
        <div id="polyline"></div>
      </div>
    </div>-->
    <Shade v-show="shade"></Shade>
    <Balance v-show="balance"></Balance>
  </div>
</template>
<script>
import Shade from "@/components/shade";
import Balance from "@/components/balance";
import api from "@/../static/common/api/api.js";
import echarts from "echarts";
import RightTop from "@/components/rightTop.vue";

export default {
  props: {},
  components: {
    Shade,
    Balance,
    RightTop
  },
  data() {
    return {
      shade: false, //遮罩
      balance: false, //遮罩
      // 日期
      selectDate: {
        value: "",
        deadline: []
      },

      stockCode: "",
      enterpriseCode: "",
      // stockCode: '600000',
      // enterpriseCode: '1',

      closingDate: "",
      announcementDate: "",
      shareholdersNumbers: "",
      averageStockHoldings: "",
      majorList: []
    };
  },
  computed: {},
  methods: {
    //   获取头部数据
    getCreditDataFn(data) {
      this.stockCode = data[0].companyStockCode;
      this.enterpriseCode = data[0].enterpriseCode;
      this.first(); //首次渲染
    },
    // 遮罩层
    lookTrends() {
      this.shade = !this.shade;
    },
    lookBalance() {
      this.balance = !this.balance;
    },

    // 首次渲染
    first() {
      this.getEquityMajorDate(); //所有日期
      setTimeout(() => {
        this.getEquityMajorData(
          this.stockCode,
          this.enterpriseCode,
          this.selectDate.value
        ); //表格数据
      }, 900);
    },
    // select点击跳转传值
    deadlineFun(val) {
      this.getEquityMajorData(this.stockCode, this.enterpriseCode, val);
      sessionStorage.setItem("endDate", JSON.stringify(val));
      // 埋点
      try {
        //LogCollection.contents["key"]="value";
        //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
        //2：收藏 3：下载 4：分享 5：购买 6：登录 7：注册 9：搜索 10：复制 11：点赞 12：评论
        LogCollection.send(9);
      } catch (e) {}
    },
    // select截止日期
    getEquityMajorDate() {
      let stockCode = this.stockCode;
      let enterpriseCode = this.enterpriseCode;
      api.stockMajorDate(stockCode, enterpriseCode).then(res => {
        this.selectDate.deadline = res.data;
        this.selectDate.value = res.data[0];

        sessionStorage.setItem("endDate", JSON.stringify(res.data[0]));
      });
    },
    // 表格数据
    getEquityMajorData(stockCode, enterpriseCode, endDate) {
      api.stockMajor(stockCode, enterpriseCode, endDate).then(res => {
        this.closingDate = res.data.data[0].closingDate;
        this.announcementDate = res.data.data[0].announcementDate;
        this.shareholdersNumbers = res.data.data[0].shareholdersNumbers;
        this.averageStockHoldings = res.data.data[0].averageStockHoldings;
        this.majorList = res.data.data;
        // console.log(this.majorList, 777777777777777);
      });
    },

    // 下载
    downloadTable() {
      this.download(
        window.baseUrl +
          "/capitalStructure/downEquityMajorData?stockCode=" +
          this.stockCode +
          "&enterpriseCode=" +
          this.enterpriseCode +
          "&endDate=" +
          this.selectDate.value
      );
      // 埋点
      try {
        //LogCollection.contents["key"]="value";
        //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
        //2：收藏
        //3：下载
        //4：分享
        //5：购买
        //6：登录
        //7：注册
        //9：搜索
        //10：复制
        //11：点赞
        //12：评论
        LogCollection.send(3);
      } catch (e) {}
    },
    download(url) {
      let a = document.createElement("a");
      a.href = url;
      let _id = Math.random() + Math.random();
      a.id = _id;
      a.click();
      window.URL.revokeObjectURL(url);
    }
  },
  created() {},
  mounted() {
    // this.first(); //首次渲染
    this.getEquityMajorDate(); //截止日期
  }
};
</script>
<style scoped lang="less">
@import "../../assets/less/style.less";

// 表格样式
// .el-table--border:after,
// .el-table--group:after,
// .el-table:before {
//   background-color: #dfdfdf;
// }

// .el-table--border,
// .el-table--group {
//   border-color: #dfdfdf;
// }

// /deep/ .el-table td,
// .el-table th.is-leaf {
//   // border-bottom: 1px solid #dfdfdf;
//   background-color: yellow;
// }

// /deep/ .el-table--border td,
// .el-table--border th {
//   border-right: 1px solid #dfdfdf;
//   border-top: 1px solid #dfdfdf;
// }
// .el-table--border {
//   border-top: 0px solid #fff;
//   border-bottom: 1px solid rgba(223, 223, 223, 1);
//   border-left: 1px solid rgba(223, 223, 223, 1);
//   border-right: 1px solid rgba(223, 223, 223, 1);
// }
// /deep/ .el-table thead {
//   color: #333;
// }
// /deep/ .el-table th > .cell {
//   font-size: 14px;
//   font-weight: bold;
// }
// /deep/ .el-table--border th,
// .el-table--border th.gutter:last-of-type {
//   border-right: 1px solid #dfdfdf;
//   background-color: rgba(247, 247, 247, 1);
// }

.right {
  flex: 1;
  height: auto;
  margin-right: 23px;
  display: flex;
  flex-direction: column;

  .rightCenter {
    width: auto;
    height: 61px;
    line-height: 61px;
    margin-right: 20px;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .centerTit {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
    }
    .centerCon {
      width: auto;
      height: 61px;
      line-height: 61px;
      display: flex;
      .no {
        span {
          display: inline-block;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333;
        }
      }
      .excel {
        margin-left: 10px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #3583ed;
        cursor: pointer;
        img {
          display: inline-block;
          width: 18px;
          height: 18px;
          transform: translate(0, 20%);
        }
      }
    }
  }
  .rightBottom {
    width: auto;
    height: auto;
    margin-right: 20px;
    padding: 20px 20px 50px 20px;
    .tabulation {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      .tabulationTop {
        width: 100%;
        height: auto;
        display: flex;
        justify-content: space-between;
        .tabulationTopTitle {
          width: 140px;
          table th {
            width: 140px;
            height: 35px;
            line-height: 35px;
            padding-left: 11px;
            vertical-align: middle;
            color: #fff;
            background-color: #375572;
            border: 1px solid #08396a;
            border-right: 0px solid #08396a;
            font-size: 14px;
            font-weight: bold;
          }
          .custom {
            height: 36px;
            line-height: 36px;
          }
        }
        .con {
          flex: 1;
          table {
            width: 100%;
          }
          table td {
            width: 16%;
            height: 35px;
            line-height: 35px;
            border: 1px solid #08396a;
            padding-left: 11px;
            color: #fff;
            vertical-align: middle;
            // 点击出遮罩层
            .trends {
              color: #3583ed;
              font-size: 12px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              margin-left: 19px;
              display: inline-block;
              cursor: pointer;
              height: 100%;
            }
          }
        }
      }
    }
  }
}
/deep/ .el-table th {
  display: table-cell !important;
}

/deep/ .el-table .cell {
  white-space: nowrap; //数据不换行
}
</style>


// WEBPACK FOOTER //
// src/view/stock/major.vue